import React, { SVGProps } from 'react';

export const Landscape = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="m8.211 11.468 2.89-3.108v7.18h1.8V8.361l2.888 3.107 1.305-1.24L12 4.8l-5.094 5.428z"
    />
    <path
      fill="currentColor"
      d="M23.4 10.2c0 7.88-1.432 8.4-11.4 8.4S.6 18.08.6 10.2 2.032 1.8 12 1.8s11.4.52 11.4 8.4m-1.8 0c0-6.352 0-6.6-9.6-6.6s-9.6.248-9.6 6.6 0 6.6 9.6 6.6 9.6-.248 9.6-6.6M16.5 22.23v-1.8h-9v1.8z"
    />
  </svg>
);
